import styled from "styled-components";

export const IconWrapper = styled.div`
    position: absolute;
    padding: 1.5rem 0 0 3.5rem;
`;
